/* Change this file to get your personal Portfolio */

// To change portfolio colors globally go to the  _globalColor.scss file

import emoji from "react-easy-emoji";
import splashAnimation from "./assets/lottie/splashAnimation"; // Rename to your file name for custom animation

// Splash Screen

const splashScreen = {
  enabled: true,
  animation: splashAnimation,
  duration: 2000
};

// Summary And Greeting Section

const illustration = {
  animated: true
};

const greeting = {
  username: "Satish Chauhan",
  title: "Hi all, I'm Satish",
  subTitle: emoji(
    "Full-Stack Software Engineer 🚀 with 3+ years of experience designing and shipping scalable web applications, REST APIs, GraphQL services, and microservices using TypeScript, Angular, React, Next.js, NestJS, and Java Spring Boot. Strong foundation in system design, microservices, OOP, design patterns, and SOLID principles. Hands-on with Agile/Scrum, CI/CD, Git, Docker, Kubernetes, and cloud deployment on AWS and Azure. Known for pragmatic problem-solving, technical leadership, and end-to-end feature ownership from concept to production"
  ),
  resumeLink: "resume.pdf",
  displayGreeting: true
};

// Social Media Links

const socialMediaLinks = {
  github: "https://github.com/Satish-Chauhan",
  linkedin: "https://www.linkedin.com/in/chauhan-satish/",
  gmail: "satishkc2000@gmail.com",
  gitlab: "https://gitlab.com/Satish-Chauhan",
  facebook: "",
  medium: "",
  stackoverflow: "",
  display: true
};

// Skills Section

const skillsSection = {
  title: "What I do",
  subTitle:
    "FULL-STACK SOFTWARE ENGINEER BUILDING SCALABLE WEB APPS, APIS, AND MICROSERVICES",
  skills: [
    emoji(
      "⚡ Build full-stack web applications using Angular, React, Next.js, Node.js, NestJS, and Java Spring Boot"
    ),
    emoji(
      "⚡ Design and implement REST APIs, GraphQL services, and distributed microservices"
    ),
    emoji(
      "⚡ Deploy and operate workloads on AWS and Azure with Docker, Kubernetes, and CI/CD pipelines"
    )
  ],

  softwareSkills: [
    { skillName: "Spring Boot", fontAwesomeClassname: "fa-solid fa-leaf" },
    { skillName: "Angular", fontAwesomeClassname: "fa-brands fa-angular" },
    { skillName: "Next.js", fontAwesomeClassname: "fa-brands fa-react" },
    { skillName: "TypeScript", fontAwesomeClassname: "fa-brands fa-typescript" },
    { skillName: "Java", fontAwesomeClassname: "fa-brands fa-java" },
    { skillName: "React", fontAwesomeClassname: "fa-brands fa-react" },
    { skillName: "Node.js", fontAwesomeClassname: "fa-brands fa-node-js" },
    { skillName: "PostgreSQL", fontAwesomeClassname: "fa-brands fa-postgresql" },
    { skillName: "JavaScript", fontAwesomeClassname: "fa-brands fa-square-js" },
    { skillName: "HTML5", fontAwesomeClassname: "fa-brands fa-html5" },
    { skillName: "CSS3", fontAwesomeClassname: "fa-brands fa-css3-alt" },
    { skillName: "Docker", fontAwesomeClassname: "fa-brands fa-docker" },
    { skillName: "Kubernetes", fontAwesomeClassname: "fa-solid fa-dharmachakra" },
    { skillName: "AWS", fontAwesomeClassname: "fa-brands fa-aws" },
    { skillName: "Azure", fontAwesomeClassname: "fa-brands fa-microsoft" },
    { skillName: "Linux", fontAwesomeClassname: "fa-brands fa-linux" },
    { skillName: "Git", fontAwesomeClassname: "fa-brands fa-git-alt" },
    { skillName: "GitHub", fontAwesomeClassname: "fa-brands fa-github" }
  ],
  display: true
};

// Education Section

const educationInfo = {
  display: true,
  schools: [
    {
      schoolName: "Chandigarh College of Engineering and Technology (CCET), Panjab University",
      logo: require("./assets/images/ccetLogo.png"),
      subHeader: "B.E. in Electronics and Communication Engineering",
      duration: "2019 - 2023",
      desc: "",
      descBullets: []
    }
  ]
};

// Your top 3 proficient stacks/tech experience

const techStack = {
  viewSkillBars: true,
  experience: [
    { Stack: "Frontend (Angular / React / Next.js)", progressPercentage: "95%" },
    { Stack: "Backend (Spring Boot / Node.js / NestJS)", progressPercentage: "95%" },
    { Stack: "DevOps & Cloud (Docker / Kubernetes / AWS / Azure)", progressPercentage: "80%" }
  ],
  displayCodersrank: false
};

// Work experience section

const workExperiences = {
  display: true,
  experience: [
    {
      role: "Software Engineer",
      company: "Quark Software Inc",
      companylogo: require("./assets/images/quark_logo.png"),
      date: "Jul 2025 – Present",
      desc: "Stepped into a technical leadership role on QPP, balancing hands-on system design and feature engineering with platform-level ownership, cross-team coordination across 5+ repositories, and stewardship of core platform components.",
      descBullets: [
        "Own end-to-end feature delivery on Quark Publishing Platform (QPP) across Angular, Java Spring Boot, NestJS, and Azure DevOps, covering system design and architecture through implementation, testing, and production rollout",
        "Driving architectural decisions for new infrastructure and platform requirements, adopting tools and practices to improve scalability, reliability, and engineering productivity",
        "Directed PR reviews across 5+ repositories spanning frontend, backend, and platform teams, enforcing engineering standards and cross-team alignment",
        "Eliminated repetitive workflows via agentic automation by authoring independent AI agents and composable skills/subagents, covering dev environment setup, code quality enforcement, and local deployment",
        "Co-owning the Content Modelling Service, QPP's structured authoring core, managing XML-based content schemas, schema-validated section hierarchies with cardinality constraints, and XSLT-driven XML-to-HTML rendering pipelines",
        "Built External WebApp Integration, a bidirectional postMessage communication framework with secure auth token exchange, achieving zero security incidents post-rollout",
        "Migrated Azure Classic Pipelines to YAML CI/CD across 3 repos, automated Docker artifact publishing, and reduced deployment time by ~45%"
      ]
    },
    {
      role: "Software Engineer I",
      company: "Quark Software Inc",
      companylogo: require("./assets/images/quark_logo.png"),
      date: "Jul 2023 – Jun 2025",
      desc: "Grew rapidly from entry-level to a trusted contributor on QPP's enterprise stack, taking on increasingly complex work spanning the full product lifecycle over a 2-year tenure.",
      descBullets: [
        "Delivered 50+ features and bug fixes on QPP in an Agile/Scrum environment, in collaboration with product, QA, and DevOps teams across sprint cycles",
        "Engineered a production-grade JaCoCo code coverage pipeline with Redis-based session management, S3 upload, and instrumented builds across microservices, uncovering 20%+ untested edge cases",
        "Led the migration of the Application Services backend from Giuseppe to NestJS, modernizing 38 controllers and 100+ REST APIs orchestrating 40+ downstream services",
        "Implemented S3 and Azure Blob Storage integration for workspace configuration import/export, enabling cross-environment portability and cutting customer onboarding time by ~50%",
        "Mentored 2 interns on Angular best practices, unit/integration testing, and code review processes"
      ]
    },
    {
      role: "Campus Intern",
      company: "Quark Software Inc",
      companylogo: require("./assets/images/quark_logo.png"),
      date: "Jan 2023 – Jun 2023",
      desc: "Campus hire entry point at Quark, onboarded onto the QPP Angular codebase and independently prototyped an AI-powered data visualization product alongside core testing responsibilities.",
      descBullets: [
        "Integrated unit testing frameworks across 4+ Angular web applications and libraries, establishing a consistent testing baseline across the codebase",
        "Developed and executed 1,000+ unit tests within 3 months, identifying and resolving 120+ bugs across multiple modules",
        "Initiated the POC for Infografix, a web application converting textual data into AI-generated graphics, and collaborated to build it from the ground up",
        "Launched Infografix within 4 months, achieving real-time rendering with no latency and AI response times averaging under 10 seconds"
      ]
    },
    {
      role: "Co-Founder & Tech Lead",
      company: "Advanture Innovations",
      companylogo: require("./assets/images/advanture_logo.png"),
      date: "Apr 2021 – Dec 2022",
      desc: "Co-founded a tech services startup managing client acquisition, project scoping, full-cycle delivery, operations, and a cross-functional team.",
      descBullets: [
        "Built 20+ client websites, mobile apps, and a SaaS billing platform with secure payment integration.",
        "Led a 3-member team with 90% client retention."
      ]
    }
  ]
};

/* Your Open Source Section to View Your Github Pinned Projects */

const openSource = {
  showGithubProfile: "false",
  display: false
};

// Some big projects you have worked on

const bigProjects = {
  title: "Projects",
  subtitle: "PRODUCTION-GRADE PRODUCTS I HAVE BUILT and CONTRIBUTED TO",
  projects: [
    {
      image: require("./assets/images/quark_logo.png"),
      projectName: "QPP (Quark Publishing Platform)",
      badge: "Contributed",
      projectDesc:
        "Quark Publishing Platform (QPP) is an AI-powered content automation solution that helps enterprises automate the production of their highly regulated or complex documentation, so they can approve and publish it faster, and stay compliant.",
      footerLink: [
        { name: "Visit Website", url: "https://www.quark.com/products/quark-publishing-platform" }
      ]
    },
    {
      image: require("./assets/images/rent-wheeler-logo.png"),
      projectName: "Rent Wheeler",
      badge: "Built",
      projectDesc:
        "Production-grade full-stack PWA car rental marketplace digitizing the largely offline self-drive rental industry. Mobile-first booking with real-time availability, multi-image carousels, transparent pricing, Razorpay-backed token payments with webhook-driven booking state sync, and an operator dashboard with per-vehicle revenue analytics, fleet/station management, and review moderation. Tech: Next.js, TypeScript, PostgreSQL, Supabase, Docker, Nginx, Razorpay.",
      footerLink: [
        { name: "Visit Website", url: "https://rentwheeler.com" }
      ]
    },
    {
      image: require("./assets/images/uniwik_logo.png"),
      projectName: "Uniwik",
      badge: "Built",
      projectDesc:
        "Trust layer for the D2C ecommerce ecosystem that protects consumers from fraudulent stores and helps legitimate brands reduce RTO losses, fake orders, and credibility gaps. Multi-step KYC onboarding, secure document handling with AWS S3, Shopify OAuth 2.0 integration, and JWT-based auth. Tech: Next.js, TypeScript, Java Spring Boot, PostgreSQL, AWS S3, AWS ECS, Docker, Nginx.",
      footerLink: [
        { name: "Visit Website", url: "https://www.uniwik.com/" }
      ]
    },
    {
      image: require("./assets/images/saas_billing_logo.png"),
      projectName: "SaaS Billing Platform",
      badge: "Built",
      projectDesc:
        "Cross-platform billing and invoicing system adopted by 100+ commercial clients, with automated payment workflows, invoice generation, and payment gateway integration — reducing payment processing errors by 40%. Tech: React, Electron.js, Node.js, Java Spring Boot, SQL, Payment Gateways.",
      footerLink: []
    }
  ],
  display: true
};

// Achievement Section

const achievementSection = {
  title: emoji("Certifications 🏆 "),
  subtitle: "Industry certifications I have earned",

  achievementsCards: [
    {
      title: "Microsoft Certified: Azure AI Engineer Associate (AI-102)",
      subtitle:
        "Microsoft certification covering design and implementation of Azure AI solutions including Azure OpenAI, Cognitive Services, and AI agents.",
      image: require("./assets/images/AI-102.png"),
      imageAlt: "Microsoft Azure AI-102 Badge",
      footerLink: [
        {
          name: "View Credential",
          url: "https://learn.microsoft.com/api/credentials/share/en-us/SatishSanjayChauhan-8871/82A4A76A7097B099?sharingId=C342DF1B07601029"
        }
      ]
    }
  ],
  display: true
};

// Blogs Section

const blogSection = {
  title: "Blogs",
  subtitle: "",
  displayMediumBlogs: "false",
  blogs: [],
  display: false
};

// Talks Sections

const talkSection = {
  title: "TALKS",
  subtitle: "",
  talks: [],
  display: false
};

// Podcast Section

const podcastSection = {
  title: emoji("Podcast 🎙️"),
  subtitle: "",
  podcast: [],
  display: false
};

// Resume Section
const resumeSection = {
  title: "Resume",
  subtitle: "Feel free to download my resume",
  display: true
};

const contactInfo = {
  title: emoji("Contact Me ☎️"),
  subtitle:
    "Discuss a project or just want to say hi? My inbox is open for all.",
  number: "+91 9011579946",
  email_address: "satishkc2000@gmail.com"
};

// Twitter Section

const twitterDetails = {
  userName: "",
  display: false
};

const isHireable = true;

export {
  illustration,
  greeting,
  socialMediaLinks,
  splashScreen,
  skillsSection,
  educationInfo,
  techStack,
  workExperiences,
  openSource,
  bigProjects,
  achievementSection,
  blogSection,
  talkSection,
  podcastSection,
  contactInfo,
  twitterDetails,
  isHireable,
  resumeSection
};
